import { render, staticRenderFns } from "./baseinfo.vue?vue&type=template&id=fc56fcce&"
import script from "./baseinfo.vue?vue&type=script&lang=js&"
export * from "./baseinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports